// frontend/src/components/ProtectedRoute.js

import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

/**
 * A component that acts as a guard for routes requiring authentication.
 * It checks the Redux store for a valid access token.
 * If the user is authenticated, it renders the child components.
 * If not, it redirects the user to the login page.
 */
function ProtectedRoute({ children }) {
  // Read the authentication status directly from the Redux store.
  const { accessToken } = useSelector((state) => state.auth);
  const location = useLocation();

  // The 'loading' state for auth is implicitly handled by the initial state of the slice.
  // If accessToken is null, we are not authenticated.
  if (!accessToken) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to. This allows us to send them back after they log in.
    // The `replace` prop prevents the user from hitting the "back" button
    // and returning to the protected route.
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If the user is authenticated, render the component they were trying to access.
  return children;
}

export default ProtectedRoute;